import 'lato-font';

import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { ThemeProvider, createGlobalStyle, theme } from './theme';
const { version } = require('../package.json');
import { seedItemsOnLogin } from './api/item';
import { ApplicationContainer } from './containers/application';
import { ApplicationStore } from './redux/modules';
import { Crisp } from 'crisp-sdk-web';
import { AuthContainer } from './containers/auth';
// import { CreditCardContainer } from "./pages/creditcard";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './components/error-fallback';
import { History } from 'history';
import { LoginContainer } from './pages/login';
import { PasswordResetContainer } from './pages/password_reset';
import { Provider } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { ApplicationContext } from './ApplicationContext';
import { RequestResetPasswordContainer } from './pages/request_reset_password';
import { SignupContainer } from './pages/signup';
import { ProfileSetupPage } from './pages/profile_setup';
// tslint:disable-next-line:no-submodule-imports
import { ProceedToCheckout } from './components/stripe/proceedToCheckout';
import { EmailVerificationIssue } from './pages/email_verification_issue';
import { getEmailVerificationList } from './api/email-verification-list';
import { addWorkroomSetting } from './api/workroom-setting';
import StripePricingTable from './pages/stripePricingTable';
import { getCustomerPlanInfo } from './api/stripe';
import { initialize_mixpanel } from './components/analytics/mixpanel';
import { QboClientExport } from './pages/qbo_client_export';
import { ProductFruits } from 'react-product-fruits';
import { initStatsig } from './statsig';
import { Config } from './utils';
import 'rc-tooltip/assets/bootstrap.css';
import EstimatePreview from './pages/EstimatePreview';
// import { handleDuplicateWorkOrders } from "./api/work-order";
// import { initialAppSync } from "./redux/modules/application";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";
// import { createPaymentIntent } from "./api/stripe";
//test commit
// tslint:disable-next-line:no-unused-expression
const GlobalStyle = createGlobalStyle`
    /* From semantic-ui global styles */
    /* stylelint-disable */
    /* Border-Box */
    *,
    *::before,
    *::after {
        -webkit-box-sizing: inherit;
        box-sizing: inherit;
    }

    html {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
/* stylelint-disable */
/* normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
}

/**
 * Correct the font size and margin on h1 elements within section and
 * article contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd em font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd em font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent sub and sup elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from fieldset elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    fieldset elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to inherit in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}
/* stylelint-enable */
    html,
    body {
        height: 100%;
    }

    html {
        font-size: 15px;
    }

    body {
        margin: 0px;
        padding: 0px;
        min-width: 320px;
        background: #FFFFFF;
        font-family: 'Poppins', Arial, Helvetica, sans-serif;
        font-size: 15px;
        line-height: 1.4285em;
        color: ${theme.colors.grayRGBA};
        font-weight: 400;
        font-smoothing: antialiased;
    }

    /*******************************
                Headers
    *******************************/

    h1,
    h2,
    h3,
    h4,
    h5 {
        font-family: 'Poppins', Arial, Helvetica, sans-serif;
        line-height: 1.28571429em;
        margin: 10px 0;
        font-weight: 200;
        padding: 0em;
    }

    h1 {
        min-height: 1rem;
        font-size: 2rem;
    }

    h2 {
        font-size: 1.71428571rem;
    }

    h3 {
        font-size: 1.28571429rem;
    }

    h4 {
        font-size: 1.07142857rem;
    }

    h5 {
        font-size: 1rem;
    }

    /*******************************
                Text
    *******************************/

    p {
        margin: 0em 0em 1em;
        line-height: 1.4285em;
    }

    p:first-child {
        margin-top: 0em;
    }

    p:last-child {
        margin-bottom: 0em;
    }

    /*-------------------
            Links
    --------------------*/

    a {
        color: #4183C4;
        text-decoration: none;
    }

    a:hover {
        color: #1e70bf;
        text-decoration: none;
    }

    /*******************************
            Scrollbars
    *******************************/

    /*******************************
            Highlighting
    *******************************/

    /* Site */

    ::-webkit-selection {
        background-color: #CCE2FF;
        color: rgba(0, 0, 0, 0.87);
    }

    ::-moz-selection {
        background-color: #CCE2FF;
        color: rgba(0, 0, 0, 0.87);
    }

    ::selection {
        background-color: #CCE2FF;
        color: rgba(0, 0, 0, 0.87);
    }

    /* Form */

    button,
    input,
    optgroup,
    select,
    textarea {
        line-height: inherit; /* 1 */
    }

    textarea::-webkit-selection,
    input::-webkit-selection {
        background-color: rgba(100, 100, 100, 0.4);
        color: rgba(0, 0, 0, 0.87);
    }

    textarea::-moz-selection,
    input::-moz-selection {
        background-color: rgba(100, 100, 100, 0.4);
        color: rgba(0, 0, 0, 0.87);
    }

    textarea::selection,
    input::selection {
        background-color: rgba(100, 100, 100, 0.4);
        color: rgba(0, 0, 0, 0.87);
    }

    /* Force Simple Scrollbars */
    body input[type="number"]::-webkit-outer-spin-button,
    body input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    body input[type="number"] {
        -moz-appearance: textfield;
    }

    body input[type="number"].sih-number-input::-webkit-outer-spin-button,
    body input[type="number"].sih-number-input::-webkit-inner-spin-button {
        -webkit-appearance: auto;
        margin: 0;
    }

    body input[type="number"].sih-number-input {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
    }

    body ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
        height: 10px;
    }

    body ::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 0px;
    }

    body ::-webkit-scrollbar-thumb {
        cursor: pointer;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.25);
        -webkit-transition: color 0.2s ease;
        transition: color 0.2s ease;
    }

    body ::-webkit-scrollbar-thumb:window-inactive {
        background: rgba(0, 0, 0, 0.15);
    }

    body ::-webkit-scrollbar-thumb:hover {
        background: rgba(128, 135, 139, 0.8);
    }

    .scrollbar-hidden {
        scrollbar-width: none;
    }

    .scrollbar-hidden::-webkit-scrollbar {
        width: 0;
        height: 0;
    }
    /* stylelint-enable */
`;

export interface RootProps {
  /**
   * Store
   */
  store: ApplicationStore;
  /**
   * History
   */
  history: History;
}

const PENDING_ACCOUNT_STATUS = 'pending';

declare global {
  interface Window {
    Statsig?: any;
  }
}
/**
 * Return token from store
 */
function getTokenFromStore(user: any): string | undefined {
  return user && user.user ? user.user.token : '';
}

function getAccountTypeFromStore(user: any): string {
  return user && user.user && typeof user.user.type === 'string' ? user.user.type : '';
}

function isLoaded(): boolean {
  return localStorage.getItem('status') === 'subscribed' || !localStorage.getItem('status');
}

// function getRefreshTokenFromStore(store: ApplicationStore): string | undefined {
//     return store.getState().user.refreshToken;
// }

/**
 * Return redirect location descriptor for cases where token is not available
 */
function getRedirect(
  user: any,
  pathname: string,
  search: string | undefined
): History.LocationDescriptor {
  const hasToken = getTokenFromStore(user);
  const accountType = getAccountTypeFromStore(user);
  if (hasToken && accountType === PENDING_ACCOUNT_STATUS) {
    return {
      pathname: '/profile-setup',
    };
  }

  const isSubscribed = user && user.user ? user.user.type === 'subscribed' : false;
  const isBeta = user && user.user ? user.user.isBeta : false;
  return {
    pathname: isSubscribed || isBeta ? '/login' : '/card',
    state: {
      redirectAfterLogin: pathname,
      redirectAfterLoginSearch: search,
    },
  };
}

function applicationAllowed(store: ApplicationStore, user: any): boolean {
  const accountType = getAccountTypeFromStore(user);
  if (accountType === PENDING_ACCOUNT_STATUS) {
    return false;
  }

  // const user = localStorage.getItem("quipa-store");
  // const hasToken = user ? JSON.parse(user).user.token : "";
  const hasToken = user && user.user ? user.user.token : '';
  // if (hasToken && hasToken !== "") {
  //     const res: any = await initialAppSync(hasToken);

  //     localStorage.setItem("accountId", res.account.id);
  //     localStorage.setItem("firstName", res.user.firstName);
  //     localStorage.setItem("lastName", res.user.lastName);
  //     localStorage.setItem("role", res.user.role);
  //     localStorage.setItem("avatarId", res.account.avatarId);
  //     localStorage.setItem("status", res.account.type);
  //     if (res.user.logoId) {
  //         localStorage.setItem("logoId", res.user.logoId);
  //     }
  // }

  const isSubscribed = user && user.user ? user.user.type === 'subscribed' : false;

  // const loaded = store.getState().application.loaded;
  // const isSubscribed = store.getState().account.type === "subscribed";
  const isBeta = user && user.user ? user.user.isBeta : false;

  if ((isSubscribed || isBeta) && hasToken) {
    return true;
  }
  // application will display loading page and will redirect to login / card when needed
  if (hasToken && hasToken !== '' && isSubscribed) {
    return true;
  }

  return false;
}

function isInviteAcceptedNavigation(search: string | undefined): boolean {
  const parsed = new URLSearchParams(search || '');
  return parsed.get('inviteAccepted') === '1';
}
/**
 * Root component
 *
 * @param props
 */
// export const ApplicationContext = createContext({
//     user:  null, // default value
//     setUser: () => {},
// });

function Root(props: RootProps): JSX.Element {
  const { history, store } = props;
  const estimatePreview = window.location.href.includes('estimate/view');

  if (estimatePreview) {
    return (
      <Router history={history}>
        <Switch>
          <Route
            path={'/estimate/view/:id'}
            render={(props: any) => {
              const pageProps = { ...props };
              return <EstimatePreview {...pageProps} />;
            }}
          />
        </Switch>
      </Router>
    );
  }

  Crisp.configure('2ae9d129-4921-4224-a351-bd47db293d11');

  let userFromStore = localStorage.getItem('quipa-store');
  userFromStore = {
    ...JSON.parse(userFromStore || '{}'),
    user: {
      ...(userFromStore && JSON.parse(userFromStore).user ? JSON.parse(userFromStore).user : {}),
      isBeta: localStorage.getItem('isBeta') === 'true',
      type: localStorage.getItem('status'),
    },
  };
  const [user, setUser] = useState(userFromStore);
  const token = getTokenFromStore(userFromStore);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  if (token !== '') {
    Crisp.setTokenId(token ? token : '');
  }
  if (!localStorage.getItem('reloadDone') || localStorage.getItem('version') !== version) {
    // Set the flag to prevent future reloads
    localStorage.setItem('reloadDone', 'true');
    localStorage.setItem('version', version);
    // add random ? to refresh server side
    const url = new URL(location.href);
    url.searchParams.set('reloadTime', Date.now().toString());
    location.href = url.toString();
    // reload
    location.reload();
  }

  if (!token && localStorage.getItem('appLoaded')) {
    localStorage.removeItem('appLoaded');
  }

  // const [options, setOptions] = useState({ clientSecret: "" });
  // const [fetched, setFetched] = useState(false);

  // const stripePromise = loadStripe("pk_test_1SiljWdVwCkxpoBGYxDSagtF");

  // useEffect(() => {
  //     if (!fetched) {
  //         createPaymentIntent().then((data) => {
  //             if (data) {
  //                 setFetched(true);
  //                 setOptions({ clientSecret: data.client_secret });
  //             }
  //         });
  //     }
  // }, []);

  // tslint:disable:jsx-alignment
  type PFUser = NonNullable<React.ComponentProps<typeof ProductFruits>['user']>;

  const getPfUser = (): PFUser | undefined => {
    try {
      const raw = localStorage.getItem('quipa-store');
      const role = localStorage.getItem('role');
      const firstName = localStorage.getItem('firstName');
      const lastName = localStorage.getItem('lastName');
      const createdAt = localStorage.getItem('createdAt');
      const parsed = raw ? JSON.parse(raw) : {};
      const u = (parsed && parsed.user) || {};

      const username =
        (u.id && String(u.id)) ||
        (u.email && String(u.email)) ||
        (u.token && String(u.token)) ||
        undefined;

      if (!username) {
        return undefined;
      }

      let env: string;

      if (location.hostname.indexOf('dev') !== -1) {
        env = 'dev';
      } else if (location.hostname.indexOf('staging') !== -1) {
        env = 'staging';
      } else if (location.hostname.indexOf('localhost') !== -1) {
        env = 'localhost';
      } else if (location.hostname.indexOf('my') !== -1) {
        env = 'prod';
      } else {
        env = 'prod';
      }

      const props: NonNullable<PFUser['props']> = {
        env: env,
      };

      if (u.item_order != null) {
        const n = Number(u.item_order);
        if (!isNaN(n)) {
          props.itemsPerPlan = n;
        }
      }

      const accountId = localStorage.getItem('accountId');
      if (accountId) {
        props.accountId = accountId;
      }

      const pfUser: PFUser = {
        username: username,
      };

      if (u.email) pfUser.email = String(u.email);
      if (firstName) pfUser.firstname = String(firstName);
      if (lastName) pfUser.lastname = String(lastName);
      if (role) pfUser.role = String(role);
      if (createdAt) pfUser.signUpAt = createdAt;
      pfUser.props = props;
      return pfUser;
    } catch {
      return undefined;
    }
  };

  const isAuthed = !!getTokenFromStore(userFromStore);
  const pfUser = isAuthed ? getPfUser() : undefined;

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event && event.key && event.key.indexOf('logout-event') === 0) {
        if (
          (window as any).productFruits &&
          (window as any).productFruits.services &&
          (window as any).productFruits.services.destroy
        ) {
          (window as any).productFruits.services.destroy();
        }
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // 🚏 notify PF about SPA route changes (react-router v5)
  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (
        (window as any).productFruits &&
        (window as any).productFruits.services &&
        (window as any).productFruits.services.pageChanged
      ) {
        (window as any).productFruits.services.pageChanged(location.pathname);
      }
    });
    return unlisten;
  }, [history]);

  const handleSeedOtherItems = async () => {
    const alreadySeeded = localStorage.getItem('seed-otheritems') || 'null';
    const parsedAlreadySeeded = JSON.parse(alreadySeeded);
    if (!parsedAlreadySeeded) {
      await seedItemsOnLogin();
      localStorage.setItem('seed-otheritems', JSON.stringify(true));
    }
  };

  const handleSeedRomanShadeConstructions = async () => {
    if (typeof window !== 'undefined') {
      // Idempotency guard — these seeds were re-running on every page load,
      // making redundant /workroomSetting/add calls (backend may dedupe, but
      // still ~300-450ms each on the wire).
      const alreadySeeded = window.localStorage.getItem('seed-romanshade-constructions');
      if (alreadySeeded && JSON.parse(alreadySeeded)) {
        return;
      }
      const accountId = window.localStorage.getItem('accountId');
      if (accountId) {
        const defaultItemList = [{ type: 4, name: 'Roman Shade' }];
        for (const defaultItem of defaultItemList) {
          const draperyFullnessValue = defaultItem.type === 3 ? 1 : 2.5;
          try {
            const result = await addWorkroomSetting({
              accountId,
              type: defaultItem.type,
              name: defaultItem.name,
              presetIsYardageAddOneExtra: true,
              presetIsYardageAddExcess: false,
              buckram: 'Ask for each order',
              presetAddExcessUnit: '%',
              presetDraperyFullnessJson: {
                value: draperyFullnessValue,
              },
            });

            if (result.error) {
              throw new Error(result.payload.message);
            }
          } catch (error) {
            console.error(error);
          }
        }
        window.localStorage.setItem('seed-romanshade-constructions', JSON.stringify(true));
      }
    }
  };

  const handleSeedDraperyConstructions = async () => {
    try {
      if (typeof window !== 'undefined') {
        // Idempotency guard — see handleSeedRomanShadeConstructions.
        const alreadySeeded = window.localStorage.getItem('seed-drapery-constructions');
        if (alreadySeeded && JSON.parse(alreadySeeded)) {
          return;
        }
        const accountId = window.localStorage.getItem('accountId');
        const defaultItemList = [
          { type: 1, name: 'Drapery | Full Length' },
          { type: 2, name: 'Drapery | Cafe Curtain' },
          { type: 3, name: 'Drapery | Ripplefold' },
        ];

        for (const defaultItem of defaultItemList) {
          const draperyFullnessValue = defaultItem.type === 3 ? 1 : 2.5;

          await addWorkroomSetting({
            accountId,
            type: defaultItem.type,
            name: defaultItem.name,
            presetIsYardageAddOneExtra: true,
            presetIsYardageAddExcess: false,
            buckram: 'Ask for each order',
            presetAddExcessUnit: '%',
            presetDraperyFullnessJson: {
              value: draperyFullnessValue,
            },
          });
        }
        window.localStorage.setItem('seed-drapery-constructions', JSON.stringify(true));
      }
    } catch (err) {
      console.log('err: ', err);
    }
  };

  // const handleFixDuplicatedWorkOrders = async () => {
  //     if (typeof window !== 'undefined') {
  //         const accountIdStorage = window.localStorage.getItem('accountId') || 'null'
  //         const parsedAccountId = JSON.parse(accountIdStorage)

  //         const accArray = window.localStorage.getItem('fix-duplicate-wo-array') || '[]'
  //         const parsedAccArray = JSON.parse(accArray)

  //         if (parsedAccArray && !parsedAccArray.includes(parsedAccountId)) {
  //             parsedAccArray.push(parsedAccountId)

  //             window.localStorage.setItem('fix-duplicate-wo-array', JSON.stringify(parsedAccArray))

  //             const res = await handleDuplicateWorkOrders()
  //             if (res) {
  //                 window.localStorage.removeItem('fix-duplicate-wo-array')
  //                 console.error('Error while getting account ID.')
  //             }
  //         }
  //     }
  // }

  useEffect(() => {
    handleSeedOtherItems();
    handleSeedRomanShadeConstructions();
    handleSeedDraperyConstructions();
    // handleFixDuplicatedWorkOrders()
    window.addEventListener('storage', (event) => {
      if (event && event.key && event.key.startsWith('logout-event')) {
        localStorage.setItem('showModal', 'true');
        window.location.href = '/login';
      }
      if (event && event.key && event.key.startsWith('login-event')) {
        window.location.href = '/';
      }
    });
  }, []);

  const fetchOrderLimit = async () => {
    const accountId = localStorage.getItem('accountId');

    if (accountId !== null) {
      const planInfoRes = await getCustomerPlanInfo(parseFloat(accountId));
      let planInfo = planInfoRes['main'];

      if (planInfo && planInfo.product_metadata && planInfo.product_metadata.item_order) {
        const item_order =
          planInfo && planInfo.product_metadata && planInfo.product_metadata.item_order
            ? planInfo.product_metadata.item_order.toString()
            : '0';

        const currentStore = localStorage.getItem('quipa-store');

        let storeObj = currentStore ? JSON.parse(currentStore) : {};

        storeObj.user = {
          ...(storeObj.user || {}),
          item_order,
        };

        localStorage.setItem('quipa-store', JSON.stringify(storeObj));
      }
    }
  };

  useEffect(() => {
    const run = () => {
      console.log('Fetching order limit...', new Date());
      fetchOrderLimit();
    };

    run(); // Run immediately on mount

    const intervalId = setInterval(run, 1 * 60 * 1000); // Run every 2 minutes

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [fetchOrderLimit]);

  useEffect(() => {
    const email = store.getState().user.email;
    if (email) {
      getEmailVerificationList(email).then((res) => {
        setIsVerified(res && res.isVerified);
      });
    }
  }, []);

  // Initialization of mixpanel
  initialize_mixpanel();
  // End code of initialization mixpanel

  useEffect(() => {
    const getUser = () => {
      try {
        const raw = localStorage.getItem('quipa-store');
        const createdAt = localStorage.getItem('createdAt');
        const sign_up_at = createdAt ? createdAt : undefined;
        const parsed = raw ? JSON.parse(raw) : {};
        const u = (parsed && parsed.user) || {};
        const userID =
          (u.id && String(u.id)) ||
          (u.email && String(u.email)) ||
          (u.token && String(u.token)) ||
          undefined;
        return { userID, email: u.email || undefined, custom: { sign_up_at } };
      } catch {
        return {};
      }
    };

    initStatsig(getUser).catch(console.error);
  }, []);

  return (
    <ApplicationContext.Provider value={{ user, setUser }}>
      <Provider store={store}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <ThemeProvider theme={theme}>
            <>
              <GlobalStyle />
              {isAuthed && pfUser && (
                <ProductFruits
                  workspaceCode={Config.productFruitsWorkspace}
                  user={pfUser}
                  language={(navigator.language || 'en').slice(0, 2).toLowerCase()}
                  lifeCycle="neverUnmount" // keeps PF around between route swaps
                />
              )}
              <Router history={history}>
                <Switch>
                  <Route
                    path="/quickbook_oauth"
                    render={(props) => {
                      const {
                        location: { query },
                      } = props;
                      if (query && window.opener) {
                        const code = query.code;
                        const realmid = query.realmId;
                        const error = query.error;

                        const payload = error
                          ? {
                              error,
                              error_description:
                                error === 'access_denied'
                                  ? 'The user did not authorize the request.'
                                  : undefined,
                            }
                          : {
                              code,
                              realmid,
                            };
                        const ev = new CustomEvent('oauthResult', {
                          detail: payload,
                        });

                        (window.opener as Window).dispatchEvent(ev);
                        window.close();
                      }
                      return null;
                    }}
                  />

                  <Route
                    path="/qbo_client_export_oauth_redirect"
                    render={(props) => (
                      <AuthContainer>
                        <QboClientExport {...props} />
                      </AuthContainer>
                    )}
                  />

                  <Route
                    path="/card"
                    render={(props) => {
                      if (isLoaded()) {
                        return getTokenFromStore(user) ? (
                          <ApplicationContainer {...props} />
                        ) : (
                          <Redirect to="/login" />
                        );
                      }
                      return (
                        <AuthContainer>
                          <ProceedToCheckout />
                          {/* {options.clientSecret ? (
                                                        <Elements
                                                            stripe={stripePromise}
                                                            options={options}
                                                        >
                                                            <CheckoutForm
                                                                clientSecret={
                                                                    options.clientSecret
                                                                }
                                                            />
                                                        </Elements>
                                                    ) : undefined} */}
                        </AuthContainer>
                      );
                    }}
                  />

                  <Route
                    path="/subscribe"
                    render={(props) => {
                      if (isLoaded()) {
                        return getTokenFromStore(user) ? (
                          <ApplicationContainer {...props} />
                        ) : (
                          <Redirect to="/login" />
                        );
                      }
                      return (
                        <AuthContainer plans={true}>
                          <StripePricingTable />
                        </AuthContainer>
                      );
                    }}
                  />

                  <Route
                    path="/profile-setup"
                    render={(props) => {
                      const hasToken = !!getTokenFromStore(user);
                      const accountType = getAccountTypeFromStore(user);
                      const inviteAccepted = isInviteAcceptedNavigation(props.location.search);

                      if (!hasToken && !inviteAccepted) {
                        return <Redirect to="/login" />;
                      }

                      if (hasToken && accountType !== PENDING_ACCOUNT_STATUS && !inviteAccepted) {
                        return <Redirect to="/" />;
                      }

                      return (
                        <AuthContainer>
                          <ProfileSetupPage />
                        </AuthContainer>
                      );
                    }}
                  />
                  <Route
                    path="/login"
                    render={(props) =>
                      getTokenFromStore(user) ? (
                        getAccountTypeFromStore(user) === PENDING_ACCOUNT_STATUS ? (
                          <Redirect to="/profile-setup" />
                        ) : (
                          <Redirect to="/" />
                        )
                      ) : (
                        <AuthContainer>
                          <LoginContainer {...props} />
                        </AuthContainer>
                      )
                    }
                  />
                  <Route
                    path="/signup"
                    render={(props) =>
                      getTokenFromStore(user) ? (
                        <Redirect to="/" />
                      ) : (
                        <AuthContainer>
                          <SignupContainer {...props} />
                        </AuthContainer>
                      )
                    }
                  />
                  <Route
                    path="/request_reset"
                    render={(props) =>
                      getTokenFromStore(user) ? (
                        <Redirect to="/" />
                      ) : (
                        <AuthContainer>
                          <RequestResetPasswordContainer {...props} />
                        </AuthContainer>
                      )
                    }
                  />
                  <Route
                    path="/password_reset"
                    render={(props) =>
                      getTokenFromStore(user) ? (
                        <Redirect to="/" />
                      ) : (
                        <AuthContainer>
                          <PasswordResetContainer {...props} />
                        </AuthContainer>
                      )
                    }
                  />
                  <Route
                    path="/email-verification-issue"
                    render={(props) =>
                      getTokenFromStore(user) && isVerified ? (
                        <Redirect to="/" />
                      ) : (
                        <AuthContainer>
                          <EmailVerificationIssue {...props} />
                        </AuthContainer>
                      )
                    }
                  />
                  <Route
                    path="/"
                    render={(props) =>
                      applicationAllowed(store, user) ? (
                        <ApplicationContainer {...props} />
                      ) : (
                        <Redirect
                          to={getRedirect(user, props.location.pathname, props.location.search)}
                        />
                      )
                    }
                  />
                </Switch>
              </Router>
            </>
          </ThemeProvider>
        </ErrorBoundary>
      </Provider>
    </ApplicationContext.Provider>
  );
  // tslint:enable:jsx-alignment
}
(Root as any).displayName = 'Root';
export default Root;
